module.exports = __webpack_public_path__ + "828443b95d68af048998190832fb305b.pdf";